(() => {
  // Arrows for the product rails.
  //
  // The scrolling is the browser's own, on a snap track, so these only nudge
  // it: a rail still works with this script missing, which is why the arrows
  // are inert markup until this runs.
  //
  // Delegated rather than bound, because the related and pairs rails replace
  // their own innerHTML when the section is fetched back with recommendations
  // in it, and anything bound to the old buttons would be pointing at elements
  // no longer in the page.
  const GAP = 12;

  const trackOf = (rail) => rail.querySelector('.prail__grid');

  // A page is what is on screen, less one card, so the card at the edge stays
  // visible after the jump and the shopper keeps their place.
  const page = (track) => {
    const card = track.firstElementChild;
    const width = card ? card.getBoundingClientRect().width + GAP : track.clientWidth;
    return Math.max(width, track.clientWidth - width);
  };

  const sync = (rail) => {
    const track = trackOf(rail);
    const nav = rail.querySelector('.prail__nav');
    if (!track || !nav) return;

    // A pixel of slack: browsers report fractional scroll positions, and an
    // exact comparison leaves the last arrow enabled at the end of the rail.
    const max = track.scrollWidth - track.clientWidth - 1;

    nav.hidden = max <= 0;

    // Not zero. The track carries the page gutter as padding so the first card
    // lines up with the rest of the page, which leaves it resting at 16 rather
    // than 0, and a "previous" arrow that never greys out at the start.
    const start = track.firstElementChild ? track.firstElementChild.offsetLeft : 0;

    const previous = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (previous) previous.disabled = track.scrollLeft <= start + 1;
    if (next) next.disabled = track.scrollLeft >= max;
  };

  const syncAll = () => document.querySelectorAll('[data-rail]').forEach(sync);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rail-prev], [data-rail-next]');
    if (!button) return;

    const rail = button.closest('[data-rail]');
    const track = rail && trackOf(rail);
    if (!track) return;

    const direction = button.hasAttribute('data-rail-prev') ? -1 : 1;
    track.scrollBy({ left: direction * page(track) });
  });

  // Capture, because a scroll event on the track does not bubble.
  document.addEventListener(
    'scroll',
    (event) => {
      const rail = event.target.closest?.('[data-rail]');
      if (rail) sync(rail);
    },
    { capture: true, passive: true }
  );

  window.addEventListener('resize', syncAll);

  // The rails are filled after their section is fetched back, so the arrows
  // have to be re-read once the cards land.
  new MutationObserver(syncAll).observe(document.body, { childList: true, subtree: true });

  syncAll();
})();
